import Cookies from "js-cookie";

const useFetch = (baseUrl: string) => {
  const getToken = () => {
    return Cookies.get("token") || "";
  };

  async function customFetch<T>(url: string, options?: RequestInit): Promise<T> {
    if (!baseUrl) {
      return Promise.reject(`baseUrl is empty ${url}`);
    }

    const headers = {
      "Content-Type": "application/json",
      ...(options?.headers || {}),
      token: getToken()
    };

    const response = await fetch(`${baseUrl}/${url}`, { ...options, headers });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json() as Promise<T>;
  }

  async function get<T>(url: string, options?: RequestInit): Promise<T> {
    return customFetch<T>(url, { ...options, method: "GET" });
  }

  async function post<T>(url: string, body?: any, options?: RequestInit): Promise<T> {
    return customFetch<T>(url, {
      ...options,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(options?.headers || {})
      },
      body: JSON.stringify(body)
    });
  }

  return {
    customFetch,
    get,
    post
  };
};

export default useFetch;
